import { useLayoutEffect, useRef, useState } from "react";

/**
 * Provides the current height and width in pixels of whatever element the ref
 * is passed to. Both values will be 0 if the ref is unused.
 *
 * IMPORTANT: the ref must be assigned on first render (i.e. not conditionally assigned)
 */
export const useElementSize = <T extends HTMLElement = HTMLDivElement>() => {
  const ref = useRef<T>(null);

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!ref.current) return;

    const containerResizeObserver = new ResizeObserver(([container]) => {
      const { inlineSize, blockSize } = container.contentBoxSize[0];

      setWidth(inlineSize);
      setHeight(blockSize);
    });

    containerResizeObserver.observe(ref.current);

    return (): void => {
      containerResizeObserver.disconnect();
    };
  }, []);

  return { ref, width, height };
};
